
(function () {
  // ---- Guard 1: bail immediately on any page that isn't a product page ----
  // Adjust the check below to match your theme (body class is common, template check is a fallback)
  var isProductPage =
    document.body.classList.contains('template-product') ||
    /^\/products\//.test(window.location.pathname);

  if (!isProductPage) return;

  var pageObserver;
  var initialized = false;

  function buildLabel(wrapperEl) {
    var optionEls = wrapperEl.querySelectorAll('.kaching-bundles-option[data-name]');
    if (!optionEls.length) return null;

    var html = '';
    optionEls.forEach(function (optionEl, idx) {
      var name = optionEl.getAttribute('data-name');
      var value = optionEl.getAttribute('data-value');

      html += '<span class="custom-variant-group">' +
                '<span class="custom-variant-name">' + name + '</span>: ' +
                '<span class="custom-variant-value">' + value + '</span>' +
              '</span>';

      if (idx < optionEls.length - 1) {
        html += '<span class="custom-variant-sep">, </span>';
      }

      if (!optionEl._namesObserved) {
        optionEl._namesObserved = true;
        new MutationObserver(function () {
          scheduleScan();
        }).observe(optionEl, { attributes: true, attributeFilter: ['data-value'] });
      }
    });

    return html;
  }

  function writeLabel(wrapperEl) {
    var newHTML = buildLabel(wrapperEl);
    if (newHTML === null) return;

    var labelDiv = wrapperEl.querySelector('.custom-variant-label');
    var needsInsert = !labelDiv;

    if (!labelDiv) {
      labelDiv = document.createElement('div');
      labelDiv.className = 'custom-variant-label';
    }

    // Skip write entirely if nothing changed
    if (!needsInsert && labelDiv.innerHTML === newHTML) return;

    // Disconnect while we write so our own mutation never gets queued/observed
    pageObserver.disconnect();

    labelDiv.innerHTML = newHTML;
    if (needsInsert) {
      wrapperEl.insertBefore(labelDiv, wrapperEl.firstChild);
    }

    pageObserver.observe(document.body, { childList: true, subtree: true });
  }

  function fixRadioTargetSize(radioEl) {
    radioEl.style.setProperty('width', '24px', 'important');
    radioEl.style.setProperty('height', '24px', 'important');
  }

  function scan() {
    document.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper').forEach(writeLabel);
    document.querySelectorAll('.kaching-bundles__bar-radio').forEach(fixRadioTargetSize);
  }

  var pending = false;
  function scheduleScan() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      scan();
    });
  }

  // ---- Guard 2: don't set up the heavy observer until the bundle block actually exists ----
  // The app embed loads asynchronously, so we wait for it (bounded by a timeout).
  function tryInit() {
    if (initialized) return;

    var bundleExists = document.querySelector('kaching-bundle, .kaching-bundles-block');
    if (!bundleExists) return;

    initialized = true;

    pageObserver = new MutationObserver(function () {
      scheduleScan();
    });
    pageObserver.observe(document.body, { childList: true, subtree: true });

    scan();
  }

  // Poll lightly for the block's arrival (cheap: just a querySelector, no heavy work)
  var attempts = 0;
  var maxAttempts = 40; // ~10s at 250ms intervals
  var pollId = setInterval(function () {
    attempts++;
    tryInit();
    if (initialized || attempts >= maxAttempts) {
      clearInterval(pollId);
    }
  }, 250);

  tryInit(); // in case it's already present at script-run time
})();